function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { handleError, isUserVerifyingPlatformAuthenticatorAvailable } from './helpers';
function getAssertionOptions(username) {
    return _getAssertionOptions.apply(this, arguments);
}
function _getAssertionOptions() {
    _getAssertionOptions = _async_to_generator(function(username) {
        var formData, res, assertionOptionsJSON, assertionOptions;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = new FormData();
                    if (username) {
                        formData.append('username', username);
                    }
                    return [
                        4,
                        fetch('/passwordless/assertionOptions', {
                            method: 'POST',
                            body: formData,
                            headers: {
                                Accept: 'application/json'
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(res, 'creating assertion options')
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        res.json()
                    ];
                case 4:
                    assertionOptionsJSON = _state.sent();
                    console.log('Assertion Options JSON Object', assertionOptionsJSON);
                    assertionOptions = PublicKeyCredential.parseRequestOptionsFromJSON(assertionOptionsJSON);
                    console.log('Assertion options', assertionOptions);
                    return [
                        2,
                        assertionOptions
                    ];
            }
        });
    });
    return _getAssertionOptions.apply(this, arguments);
}
export function tryPasswordlessSignIn(abortController) {
    return _tryPasswordlessSignIn.apply(this, arguments);
}
function _tryPasswordlessSignIn() {
    _tryPasswordlessSignIn = _async_to_generator(function(abortController) {
        var assertionOptions, credential, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        isUserVerifyingPlatformAuthenticatorAvailable()
                    ];
                case 1:
                    if (!_state.sent()) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        PublicKeyCredential.isConditionalMediationAvailable()
                    ];
                case 2:
                    if (!_state.sent()) {
                        console.log('Conditional mediation is not available');
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        getAssertionOptions(null)
                    ];
                case 3:
                    assertionOptions = _state.sent();
                    console.log('Trying to get passwordless credential');
                    return [
                        4,
                        navigator.credentials.get({
                            publicKey: assertionOptions,
                            mediation: 'conditional',
                            signal: abortController.signal
                        })
                    ];
                case 4:
                    credential = _state.sent();
                    if (!credential) {
                        console.log('No passwordless credentials found');
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        verifyAssertionWithServer(credential)
                    ];
                case 5:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _tryPasswordlessSignIn.apply(this, arguments);
}
export function handlePasswordlessSignIn(username) {
    return _handlePasswordlessSignIn.apply(this, arguments);
}
function _handlePasswordlessSignIn() {
    _handlePasswordlessSignIn = _async_to_generator(function(username) {
        var assertionOptions, credential, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getAssertionOptions(username)
                    ];
                case 1:
                    assertionOptions = _state.sent();
                    return [
                        4,
                        navigator.credentials.get({
                            publicKey: assertionOptions
                        })
                    ];
                case 2:
                    credential = _state.sent();
                    if (!credential) {
                        throw new Error('Could not get credential');
                    }
                    return [
                        4,
                        verifyAssertionWithServer(credential)
                    ];
                case 3:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _handlePasswordlessSignIn.apply(this, arguments);
}
function verifyAssertionWithServer(assertedCredential) {
    return _verifyAssertionWithServer.apply(this, arguments);
}
function _verifyAssertionWithServer() {
    _verifyAssertionWithServer = _async_to_generator(function(assertedCredential) {
        var res;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(assertedCredential instanceof PublicKeyCredential)) {
                        throw new Error("Expected PublicKeyCredential, got ".concat(typeof assertedCredential === "undefined" ? "undefined" : _type_of(assertedCredential)));
                    }
                    return [
                        4,
                        fetch('/passwordless/makeAssertion', {
                            method: 'POST',
                            body: JSON.stringify(assertedCredential),
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json'
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleError(res, 'doing assertion')
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return _verifyAssertionWithServer.apply(this, arguments);
}
